module.exports = __webpack_public_path__ + "assets/img/record_audio_anim.695fcd0b.png";